// Tolerant date parsing for backend timestamps.
//
// The backend serializes timestamps (e.g. `date_uploaded`) as "YYYY-MM-DD HH:MM:SS" — space
// separated, no timezone. V8 (Chrome/Opera) leniently parses that as local time, but WebKit
// (iOS Safari) returns an Invalid Date because the space separator is non-standard. That surfaces
// on iPhone only as literal "Invalid Date" text and as NaN comparators that scramble sort order.
//
// Normalizing the space to a 'T' makes both engines parse the string identically (as local time,
// matching the previous Chrome behaviour — no displayed-time shift). ISO strings, numbers, and
// Date objects pass through unchanged.
export function parseServerDate(value) {
  if (value instanceof Date) return value
  if (typeof value === 'string') {
    return new Date(
      value.replace(/^(\d{4}-\d{2}-\d{2}) (\d{2}:\d{2}:\d{2})/, '$1T$2'),
    )
  }
  return new Date(value ?? 0)
}
